import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { aclDecorator } from 'Decorators';
import Lightbox from 'Common/Lightbox';
import Button from 'Common/CustomButtons/Button';
import { storeInvitation } from 'Actions/invitation';
import { loadDataByAlias } from 'Actions/mailTemplate';
import SettingsInvitationForm from '../components/SettingsInvitationForm';
import { ROLES_HAS_JOURNAL } from 'Constants';

@aclDecorator()
@connect(
    store => ({
        user: store.auth.user,
        template: store.mailTemplateData.template,
        journalsData: store.journalsListAutocomplete.data,
        loading: store.invitationList.loading
    }),
    dispatch => ({
        storeInvitation: data => dispatch(storeInvitation(data)),
        loadTemplateByAlias: alias => dispatch(loadDataByAlias(alias)),
    })
)
export default class SettingsInvitationSend extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        user: PropTypes.object.isRequired,
        template: PropTypes.object.isRequired,
        storeInvitation: PropTypes.func.isRequired,
        loadTemplateByAlias: PropTypes.func.isRequired,
        isOneOf: PropTypes.func.isRequired,
        journalsData: PropTypes.array,
        loading: PropTypes.bool
    };

    componentDidMount() {
        const { loadTemplateByAlias } = this.props;
        loadTemplateByAlias('invitation-new');
    }

    state = {
        isOpen: false,
    };

    getInitialValues = () => {
        const {
            template: { body, subject },
        } = this.props;

        return { body, subject };
    };

    getJournalFilter = () => {
        const { isOneOf } = this.props;

        if (isOneOf(ROLES_HAS_JOURNAL)) {
            const {
                user: {
                    activeRole: { journals },
                },
            } = this.props;

            return { where: { id: { inq: journals } } };
        }

        return {};
    };

    /**
     * Open lightbox handler
     */
    openLightbox = () => {
        this.setState({ isOpen: true });
    };

    /**
     * Submit lightbox handler
     */
    handleSubmit = data => {
        const { storeInvitation } = this.props;
        storeInvitation(data).then(() => this.handleClose());
    };

    /**
     * Close lightbox handler
     */
    handleClose = () => {
        this.setState({ isOpen: false });
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const { journalsData, loading } = this.props;
        const { isOpen, activeStep } = this.state;

        return (
            <div>
                <Button color="primary" onClick={this.openLightbox}>
                    <FormattedMessage id="button.invitations.new" />
                </Button>

                <Lightbox
                    maxWidth="md"
                    scroll="body"
                    handleClose={this.handleClose}
                    isOpen={isOpen}
                    title="title.invitations.create"
                >
                    <SettingsInvitationForm
                        initialValues={this.getInitialValues()}
                        activeStep={activeStep}
                        onSubmit={this.handleSubmit}
                        handleClose={this.handleClose}
                        journalProps={{filter: this.getJournalFilter()}}
                        journalsData={journalsData}
                        loading={loading}
                    />
                </Lightbox>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Settings/containers/SettingsInvitationSend.jsx